import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { AuthType } from '@/const/auth';
import { fetchAiUsage } from '@/services/aigc';

export interface Inner_token {
  vuser: string;
  vsession_key: string;
  expire_time: string;
}

export interface Wxuser_token_info {
  wx_nick_name: string;
  wx_faceimage_url: string;
  wx_openid: string;
  access_token: string;
  refresh_token: string;
  access_token_expiretime: string;
}

export interface LoginInfo {
  name?: string;
  avatar?: string;
  inner_token?: Inner_token;
  wxuser_token_info?: Wxuser_token_info;
  qquser_token_info?: any;
  hwencrypt_info?: any;
  bnew_user?: boolean;
  next_logintype?: string;
  extend_data?: any;
  vuserver_token?: any;
  user_token_info?: any;
  tel_bind_info?: any;

  telLast?: string;
}

export interface UserState {
  name: string;
  vuid: string;
  head: string;
  userType?: AuthType;
  loginStatus: string;
  loginInfo: LoginInfo;
  expireTime: number; // seconds 登录过期时间 需要续期
  wxExpireTime: number; // seconds 微信登录过期时间 重新登录
  onVideoWhiteList?: boolean; // 是否在AI视频白名单
}

export const LOGIN_STATUS = {
  INIT: 'init',
  SUCCESS: 'success',
  FAIL: 'fail',
  NOT_LOGIN: 'notLogin',
};

export enum LOGIN_TYPE {
  WX = 'wx',
  QQ = 'qq',
  PHONE = 'phone',
}

export const LOGIN_TYPE_ENUM = {
  [LOGIN_TYPE.WX]: '微信',
  [LOGIN_TYPE.QQ]: 'QQ',
  [LOGIN_TYPE.PHONE]: '手机号',
};


const initialState: UserState = {
  name: '梦予用户',
  vuid: '',
  head: 'https://nova.file.video.qpic.cn/uploadFile/1c726328bbb98903ce50754515f0a99a7c11e0c2945360e9a8979055bd5da343.png',
  userType: AuthType.UGC,
  loginStatus: LOGIN_STATUS.INIT,
  loginInfo: {},
  expireTime: 0,
  wxExpireTime: 0,
};

export const getUserInfo = createAsyncThunk('user/info', () => ({ name: '', vuid: '', head: '' }));

export const getAiUsage = createAsyncThunk('user/aiUsage', fetchAiUsage);

export const userInfo = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setLoginStatus(state, { payload }) {
      state.loginStatus = payload;
    },
    setUserAuth(state, { payload }) {
      state.userType = payload.userType || AuthType.UGC;
    },
    updateBaseUserInfo(state, { payload }) {
      return {
        ...state,
        ...payload,
      };;
    },
    changeLoginInfo(state, { payload }: {
      payload: {
        name: string;
        avatar: string;
        vuid: string;
      }
    }) {
      const userInfo = {
        name: payload?.name,
        head: payload?.avatar,
        vuid: payload?.vuid,
      };

      return {
        ...state,
        ...userInfo,
      };
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getUserInfo.fulfilled, (state, { payload }) => {
      if (!payload) {
        return initialState;
      }
      state.name = payload.name;
      state.vuid = payload.vuid;
    });
    builder.addCase(getAiUsage.fulfilled, (state, { payload }: any) => {
      if (payload?.find((item: any) => String(item.user_id) === String(state.vuid) && item.resource_type === 3)) {
        state.onVideoWhiteList = true;
      }
    });
  },
});

export const { setUserAuth, setLoginStatus, changeLoginInfo, updateBaseUserInfo } = userInfo.actions;

export default userInfo.reducer;
